import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../auth/base/services/auth.service';
import { ApiError } from '../../../core/models/api-error.model';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  isDev = environment.dev;

  constructor(private readonly router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        if (this.isDev) {
          this.displayError(httpError);
        }

        if (!AuthService.refreshing && httpError.status === 500) {
          this.handleInternalServerError(httpError.error);
        } else if (
          !AuthService.refreshing &&
          httpError.status === 503 &&
          httpError.error.message.includes('maintenance')
        ) {
          this.router.navigateByUrl('/maintenance-mode');
        }

        return throwError(httpError);
      })
    );
  }

  private displayError(httpError: HttpErrorResponse) {
    console.log(httpError);
  }

  private handleInternalServerError(error: ApiError): void {}
}
